import store from '@ps/store'
import { Event, EventBus } from '@ps/utils/event-bus'
import i18n from '@ps/lang'
import { resetNodeDefaultLayout } from '@ps/bridge/qc/node/utils'
import nodePool from '@ps/bridge/qc/node-pool'
import gameIframe from '@ps/bridge/iframe/iframe'
import {
  DragBoundClass,
  DragTargetAreaClass,
  isScene,
} from '@ps/bridge/qc/base'

export default async function ({ state, rootState }) {
  const scene = rootState.workspace.game.sceneManager.currentSceneNode
  const gameOb = state.data.gameOb
  const res = gameOb.assets.find('__builtin_resource__')
  const emptyTexture = res.getTexture('empty.png')
  const node = gameOb.add.image(scene)
  resetNodeDefaultLayout(node)
  node.texture = emptyTexture
  node.name = i18n.t('workbench.eventSetting.eventHand.dragArea')
  node.width = 200
  node.height = 200
  node.addScript(DragTargetAreaClass)
  store.dispatch('workspace/game/updateActiveNode', {
    node,
    record: false,
  })
  store.dispatch('workspace/stage/addVirtualNode', node)
  EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
  return await node.uuid
}

export function getFirstLevelNode(node) {
  while (!isScene(node.parent)) {
    node = node.parent
  }
  return node
}

export async function addDragBound({ state, rootState }, dragerNode) {
  const scene = rootState.workspace.game.sceneManager.currentSceneNode
  const gameOb = state.data.gameOb
  const res = gameOb.assets.find('__builtin_resource__')
  const emptyTexture = res.getTexture('empty.png')
  const node = gameIframe.qcGame.add.image()
  const firstLevelNode = getFirstLevelNode(dragerNode)
  const index = scene.getChildIndex(firstLevelNode)
  scene.addChildAt(node, index + 1)
  resetNodeDefaultLayout(node)
  node.texture = emptyTexture
  node.name = i18n.t('workbench.eventSetting.eventBlock.dragBound')
  node.width = gameIframe.UIRoot.width
  node.height = gameIframe.UIRoot.height
  node.addScript(DragBoundClass)
  store.dispatch('workspace/game/updateActiveNode', {
    node,
    record: false,
  })
  store.dispatch('workspace/stage/addVirtualNode', node)
  EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
  return await node
}

export async function recoverDragTargetAreaByUuid({ rootState }, uuid) {
  const scene = rootState.workspace.game.sceneManager.currentSceneNode
  const node = nodePool.find(uuid)
  // 已经在节点树里的就不用重复添加了
  if (node.parent) {
    return
  }
  scene.addChild(node)
  store.dispatch('workspace/stage/addVirtualNode', node)
  EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
  return await node.uuid
}

export async function recoverDragBoundByUuid(
  { rootState },
  { uuid, dragerNode },
) {
  const scene = rootState.workspace.game.sceneManager.currentSceneNode
  const node = nodePool.find(uuid)
  // 已经在节点树里的就不用重复添加了
  if (node.parent) {
    return
  }
  const firstLevelNode = getFirstLevelNode(dragerNode)
  const index = scene.getChildIndex(firstLevelNode)
  scene.addChildAt(node, index + 1)
  store.dispatch('workspace/stage/addVirtualNode', node)
  EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
  return await node.uuid
}
